import { observer } from "mobx-react-lite";

import { useSchemaEditor } from "../..";
import { ISchemaParameter } from "../schema-parameter-store";

import { Input } from "@/components/ui/input";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface Props {
  parameter: ISchemaParameter;
}

const NumberParameterContent = observer(({ parameter }: Props) => {
  const editor = useSchemaEditor();
  const { isReadonly } = editor;

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="number-constraints" className="text-xs">
        <AccordionTrigger className="font-normal text-gray-700">
          Number Constraints
        </AccordionTrigger>
        <AccordionContent>
          <div className="grid grid-cols-4 gap-4 sm:grid-cols-2 md:grid-cols-3">
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-500">Minimum</label>
              <Input
                value={parameter.minimum ?? ""}
                onChange={e => parameter.setMinimum(e.target.value)}
                readOnly={isReadonly}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-500">Maximum</label>
              <Input
                value={parameter.maximum ?? ""}
                onChange={e => parameter.setMaximum(e.target.value)}
                readOnly={isReadonly}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-500">Multiple Of</label>
              <Input
                value={parameter.multipleOf ?? ""}
                onChange={e => parameter.setMultipleOf(e.target.value)}
                readOnly={isReadonly}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-500">Exclusive Minimum</label>
              <Input
                value={parameter.exclusiveMinimum ?? ""}
                onChange={e => parameter.setExclusiveMinimum(e.target.value)}
                readOnly={isReadonly}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-500">Exclusive Maximum</label>
              <Input
                value={parameter.exclusiveMaximum ?? ""}
                onChange={e => parameter.setExclusiveMaximum(e.target.value)}
                readOnly={isReadonly}
              />
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
});

export { NumberParameterContent };
